require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./summer-winter-schools-2-3-5.json") })
        }
      }, "path---summer-winter-schools-2-3-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---summer-winter-schools-2-3-5!./.cache/json/summer-winter-schools-2-3-5.json
// module id = 582
// module chunks = 231608221292675